/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{ScreenSpacePass as e}from"../views/3d/webgl-engine/core/shaderLibrary/ScreenSpacePass.glsl.js";import{NoParameters as r,glsl as o}from"../views/3d/webgl-engine/core/shaderModules/interfaces.js";import{ShaderBuilder as t}from"../views/3d/webgl-engine/core/shaderModules/ShaderBuilder.js";import{Texture2DPassUniform as s}from"../views/3d/webgl-engine/core/shaderModules/Texture2DPassUniform.js";class a extends r{}function n(r){const a=new t;a.include(e),a.fragment.uniforms.add(new s("colorTexture",(e=>e.color)),new s("depthTexture",(e=>e.depth)));const n=r.haze;return a.fragment.code.add(o`
    void main() {
      float depthSample = texture(depthTexture, uv).r;
      if (depthSample ${n?o`== 1.0`:o`!= 1.0`} ) {
          fragColor = vec4(0);
          return;
      }
      fragColor = texture(colorTexture, uv);
    }
    `),a}const d=Object.freeze(Object.defineProperty({__proto__:null,AtmosphereCompositingPassParameters:a,build:n},Symbol.toStringTag,{value:"Module"}));export{a as A,d as a,n as b};
